/** One tenancy-resolved policy supplies badge grading and read visibility. */
import * as React from "react";
import { ConfidenceCutoffsProvider, ReadConfidenceProvider, useConfidencePolicy } from "@authe/ui-core";
import { readConfidencePolicy, readTierCutoffs } from "@authe/fe-commons/evidence";
import { useEvidencePolicySource } from "@/api/adapters";

export function DashboardConfidenceCutoffs({ children }: { children: React.ReactNode }): React.ReactElement {
  const source = useEvidencePolicySource();
  const { data, status } = useConfidencePolicy(source);
  const effective = data?.effective;
  // Tolerant of `"0.7"`: the backend reads a text cutoff as a number, and a
  // reader that did not graded badges on platform lines the gate had moved off.
  const cutoffs = readTierCutoffs(effective?.tier_cutoffs);
  const policy = React.useMemo(() => readConfidencePolicy(effective), [effective]);
  return <ConfidenceCutoffsProvider cutoffs={cutoffs}>
    <ReadConfidenceProvider policy={policy} loading={!data && status !== "error"}>
      {children}
    </ReadConfidenceProvider>
  </ConfidenceCutoffsProvider>;
}
